<div class="prize-card" [class.prize-card--disabled]="group.available_instant_wins === 0">

  <div class="prize-card__head"  #prizeCardHeadRef (click)="toogleCard()">
    <div class="prize-card__img">
      <img *ngIf="group.media_info" [src]="group.media_info.big" [alt]="group.prize_name" (click)="$event.stopPropagation(); handleShowGallery()">
    </div>
    <p class="prize-card__name"> {{group.prize_name}} </p>
    <span class="prize-card__badge" *ngIf="group.available_instant_wins === 0">Already Won</span>
    <span class="prize-card__badge" *ngIf="group.available_instant_wins !== 0">
      <span *ngIf="group.number_of_prizes !== 1">{{group.available_instant_wins}}/{{group.number_of_prizes}}</span>
      To Be Won
    </span>
    <button type="button" class="prize-card__toogle" [class.prize-card__toogle--open]="showBody" [class.prize-card__toogle--disabled]="group.available_instant_wins === 0" >
      <svg-icon name="arrow" fill="#FFFFFF"></svg-icon>
    </button>
  </div>
  <div class="prize-card__content" [class.prize-card__content--opened]="showBody" [@toggleItem]="showBody ? 'in' : 'out'">
    <div class="prize-card__tabs" *ngIf="showDescription">
      <button type="button" [class.active-tab]="showTickets" (click)="showTickets = true">Tickets</button>
      <button type="button" [class.active-tab]="!showTickets" (click)="showTickets = false"> Description</button>
    </div>
    <div class="prize-card__tab-content" [class.prize-card__tab-content--paginations]="pages?.length > 1" *ngIf="showTickets">
      <div class="prize-card__tickets-box" #ticketBoxRef *ngIf="tickets?.length > 0">
        <div class="prize-card__tickets-content"  [style.width.px]="ticketGrid * ticketWidth" >
          <div class="prize-card__ticket-card" *ngFor="let item of tickets" [class.prize-card__ticket-card--sold-out]="item.is_available === false">
            <div class="prize-card__ticket-card-content">
              {{item.ticket_number}}
            </div>
            <div class="prize-card__ticket-card-footer">{{  item.is_available ? 'WIN NOW' : 'ALREADY WON'}}</div>
          </div>
        </div>
      </div>
    
      <div class="prize-card__paginations paginations" *ngIf="pages?.length > 1">
        <button type="button" class="paginations__prev" [disabled]="currentPage === 0" (click)="changePage(currentPage-1)">
          <svg-icon name="arrow" fill="#6E7A84"></svg-icon>
        </button>
        <ng-container *ngFor="let page of pages">

          <span class="paginations__dots" *ngIf="page.page === null">{{page.text}}</span>
          <button type="button" (click)="changePage(page.page)" class="paginations__page" [class.paginations__page--active]="currentPage === page.page" *ngIf="page.page !== null">{{page.text}}</button>

        </ng-container>
        <button type="button" class="paginations__next" [disabled]="currentPage === maxPage" (click)="changePage(currentPage+1)">
          <svg-icon name="arrow" fill="#6E7A84"></svg-icon>
        </button>
      </div>

      <div *ngIf="isLoading" class="loader-icon__box">
        <svg-icon name="circle-notch" [spin]="true" class="loader-icon__icon"></svg-icon>
      </div>
    </div>
    <div class="prize-card__tab-content" *ngIf="!showTickets">
      <span class="prize-card__tab-conten-title">{{group.prize_name}}</span>
      <article [innerHTML]="group?.description | safeHtml"></article>
    </div>
  </div>
</div>